import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { LogIn } from 'lucide-react-native';
import { useTheme, SPACING, BORDER_RADIUS, TYPOGRAPHY } from '../../theme';
import { useAuthGateStore } from '../../store/authGateStore';

interface SignInChipProps {
  variant?: 'pill' | 'bare';
  testID?: string;
}

export function SignInChip({ variant = 'pill', testID }: SignInChipProps) {
  const { colors } = useTheme();
  const iconSize = variant === 'pill' ? 16 : 18;

  return (
    <TouchableOpacity
      onPress={() =>
        useAuthGateStore.getState().open(() => {}, { message: 'Sign in to access your account' })
      }
      accessibilityRole="button"
      accessibilityLabel="Sign in"
      testID={testID}
      hitSlop={8}
      style={[
        styles.base,
        variant === 'pill' && [
          styles.pill,
          { backgroundColor: colors.surface, borderColor: colors.border },
        ],
      ]}>
      <LogIn size={iconSize} color={colors.primary} />
      <Text style={[styles.text, { color: colors.primary }]}>Sign In</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: SPACING.xs,
  },
  pill: {
    paddingHorizontal: SPACING.smd,
    paddingVertical: SPACING.sm,
    borderRadius: BORDER_RADIUS.full,
    borderWidth: 1,
  },
  text: {
    ...TYPOGRAPHY.label,
  },
});
